'use strict';

(function() {
	angular
		.module('dat.shared-components.common')
		.filter('phoneNumber', function () {
			return function(phoneNumber) {
				if (!phoneNumber) {
					return '';
				}

				var length = phoneNumber.length;

				if (length === 10) {
					var areaCode = phoneNumber.slice(0, 3);
					var prefix = phoneNumber.slice(3, 6);
					var suffix = phoneNumber.slice(6,10);

					return ('(' + areaCode + ') ' + prefix + '-' + suffix);
				} else {
					return phoneNumber;
				}
			};
		});
})();
